export default "__VITE_ASSET__CDyQU90O__"